<script>
import {mapGetters} from 'vuex';
import {UserRole} from '@/store/modules/users';

export default {
   name: 'StaffDashboardUser',
   props: {
      id: {
         type: String,
      },
      type: {
         type: String,
      },
      email: {
         type: String,
      },
   },
   computed: {
      ...mapGetters('users', ['userMap']),
      UserRole() {
         return UserRole;
      },
      profile() {
         return this.userMap[this.id] || null;
      },
      shouldShow() {
         return !!this.profile;
      },
      imgSrc() {
         return {
            src: `/api/user/${this.id}/profile/image`,
            fallbackUrl: require('@/assets/img/avatar.svg'),
         };
      },
      profileName() {
         return this.profile ? `${this.profile.firstName} ${this.profile.lastName}` : '';
      },
      profileTitle() {
         return this.profile ? this.profile.title : '';
      },
   },
   methods: {
      handleEmailClick() {
         this.$emit('email-selected', this.email);
      },
   },
};
</script>

<template>
   <div v-if="shouldShow" class="d-flex py-2 pr-2" style="">
      <component
         href="#"
         :is="
            [
               UserRole.BUSINESS_MANAGER,
               UserRole.PROJECT_MANAGER,
               UserRole.PROJECT_ASSOCIATE,
            ].includes(type)
               ? 'a'
               : 'span'
         "
         class="user__link"
         target="_blank"
         @click.prevent="handleEmailClick"
      >
         <img v-auth-src="imgSrc" class="user__image" alt="user image" />
         <div class="user__text-wrapper">
            <div class="user__name text-truncate">
               {{ profileName }}
            </div>
            <div class="user__title text-truncate">{{ type || profileTitle }}</div>
         </div>
      </component>
   </div>
</template>

<style scoped lang="scss">
.user {
   &__name {
      font-size: 0.625rem;
      font-weight: 600;
   }

   &__title {
      font-size: 0.5rem;
   }

   &__text-wrapper {
      max-width: 5.5rem;

      @media (max-width: 1140px) {
         max-width: 3.7rem;
      }
   }

   &__image {
      height: 1.875rem;
      width: 1.875rem;
      border-radius: 100%;
      margin-right: 0.5rem;
   }

   &__link {
      text-decoration: none;
      display: flex;
      align-items: center;
   }
}
</style>
